import React, { FC } from 'react';
import { SVG } from "./SVG";

export const CheckMark: FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <SVG {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" isIcon>
        <path d="M9.99996 15.17L19.193 5.979L20.607 7.393L10.001 17.999L3.63696 11.635L5.05096 10.221L10.001 15.171L9.99996 15.17Z" />
    </SVG>
);